import { render, staticRenderFns } from "./Profissionais.vue?vue&type=template&id=efe5ea78&scoped=true&"
import script from "./Profissionais.vue?vue&type=script&lang=js&"
export * from "./Profissionais.vue?vue&type=script&lang=js&"
import style0 from "./Profissionais.vue?vue&type=style&index=0&id=efe5ea78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe5ea78",
  null
  
)

export default component.exports